import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { AuthImage } from "@/components/AuthImage";
import { MapPin, Calendar as CalendarIcon, Trash2 } from "lucide-react";

export default function TripCard({ trip, index, onDelete }) {
  const nav = useNavigate();
  const { id, name, trip_type, destination, cover_file_id, start_date, end_date } = trip;

  return (
    <div
      key={id}
      onClick={() => nav(`/trips/${id}`)}
      className="group cursor-pointer rounded-2xl overflow-hidden border border-border bg-card hover:shadow-md hover:-translate-y-1 transition-transform"
      style={{ animation: `fade-in-up 0.4s ease-out ${index * 60}ms both` }}
      data-testid={`trip-card-${id}`}
    >
      <div className="relative h-40 bg-muted">
        <AuthImage fileId={cover_file_id} className="w-full h-full object-cover" fallbackClassName="w-full h-full" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
        <div className="absolute inset-x-0 bottom-0 p-4 text-white">
          <div className="text-xs uppercase tracking-widest opacity-80">{trip_type}</div>
          <div className="font-display text-xl leading-tight">{name}</div>
        </div>
      </div>
      <div className="p-4 flex items-center justify-between">
        <div className="text-sm text-stone-600 space-y-1">
          <div className="flex items-center gap-1.5"><MapPin className="w-3.5 h-3.5 text-primary" /> {destination}</div>
          {(start_date || end_date) && (
            <div className="flex items-center gap-1.5 text-xs text-stone-500">
              <CalendarIcon className="w-3.5 h-3.5" />
              {start_date || "?"} — {end_date || "?"}
            </div>
          )}
        </div>
        <Button
          variant="ghost" size="icon"
          onClick={(e) => { e.stopPropagation(); onDelete(id); }}
          className="rounded-full text-stone-400 hover:text-destructive"
          data-testid={`delete-trip-${id}`}
        >
          <Trash2 className="w-4 h-4" />
        </Button>
      </div>
    </div>
  );
}
